import React from 'react'
import { Link } from "react-router-dom"
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CardUI from '../../../widgets/layout/CardUI'

const ComplianceTaskListPageUI = ({ context, errorList, complianceTaskList, onRefreshClick }) => (
  <SuperUserHomePageUI
    context={context} className='pg_su_ld' topnav='accounts'
    centered={!complianceTaskList && !errorList} page='complianceTask'
  >
    {
      (!complianceTaskList && !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {
      complianceTaskList &&
      <LRTableActionsUI
        location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Compliance Calendar</b></span>
          </span>
        }
        right={
          <a href='https://app.clickup.com/7218019/v/l/6-901603863765-1' target='_blank'>
            app.clickup.com/7218019/v/l/6-901603863765-1
          </a>
        }
      />
    }
    {
      complianceTaskList && complianceTaskList.length === 0 && (
        <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No Sales Reports' />
      )
    }
    {
      complianceTaskList && complianceTaskList.length > 0 && (
        <div>

          <CardUI>
            <table>
              <thead>
                <tr>
                  <th>Due Date</th>
                  <th className='g_p_left_100'>Task</th>
                  <th className='g_p_left_100'>Assignee</th>
                  <th className='g_p_left_100'>Status</th>
                </tr>
              </thead>
              <tbody>
                {complianceTaskList.map((task, index) => (
                  <tr key={index}>
                    <td className='g_text_top g_no_wrap_2'>{task.dueDateF1}</td>
                    <td className='g_p_left_100'>
                      {task.name}<br/>
                      <span className='g_small'>{task.textContent}</span>
                    </td>
                    <td className='g_p_left_100 g_text_top g_no_wrap_2'>{task.assigneeName}</td>
                    <td className='g_p_left_100 g_text_top'>{task.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardUI>
        </div>
      )
    }

  </SuperUserHomePageUI>
)

export default ComplianceTaskListPageUI
